import React from "react"

function Chevron() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.0037 10.8235L1.05081 3.87062C0.810408 3.63025 0.420653 3.63025 0.180249 3.87062C-0.0600829 4.11106 -0.0600829 4.50078 0.180249 4.74118L7.56842 12.1294C7.80882 12.3697 8.19858 12.3697 8.43898 12.1294L15.8271 4.74118C16.0634 4.4966 16.0566 4.10684 15.812 3.87062C15.5734 3.64021 15.1951 3.64021 14.9566 3.87062L8.0037 10.8235Z"
        fill="#414141"
      />
    </svg>
  )
}

export default Chevron
